import React from 'react';
import { DEFAULT_PERSON_LAST_NAME } from '../../../person/utils/personConstants';

export const getNameLabel = (name: unknown): string => {
    if (typeof name === 'string') {
        return name;
    }

    if (name && typeof name === 'object') {
        const maybeName = name as { firstName?: string; lastName?: string };
        const firstName = maybeName.firstName || '';
        const lastName = maybeName.lastName === DEFAULT_PERSON_LAST_NAME ? '' : maybeName.lastName;
        const fullName = `${firstName} ${lastName}`.trim();
        return fullName;
    }

    return '';
};

export const resolveOptionLabel = (item: any): string => {
    return (
        item?.label ||
        item?.subLabel ||
        getNameLabel(item?.name) ||
        item?.ref?.label ||
        item?.reference?.label ||
        item?.personReference?.label ||
        ''
    );
};

export const markMatch = (option, term) => {
    const optionLabel = resolveOptionLabel(option);
    const matchLabel = optionLabel.toUpperCase().indexOf(term.toUpperCase());
    const matchSubLabel = option.subLabel?.toUpperCase().indexOf(term.toUpperCase());

    // If there is no match return the unchanged text.
    if (matchLabel < 0 && (matchSubLabel === undefined || matchSubLabel < 0)) {
        return optionLabel;
    }

    const match = matchLabel >= 0 ? matchLabel : matchSubLabel;
    const text = matchLabel >= 0 ? optionLabel : option.subLabel;

    const pre = text.substring(0, match);
    const mid = text.substring(match, match + term.length);
    const post = text.substring(match + term.length);

    return (
        <>
            {pre}
            <b>{mid}</b>
            {post}
        </>
    );
};
